export { default as PersistentCartProduct } from './persistentCartProduct'



// WEBPACK FOOTER //
// ./src/modules/persistent-cart/persistentCartProduct/index.js